import React, { useState, useMemo } from "react";
import StudentListItem from "./StudentListItem";

const NAV_ITEMS = [
	{ key: "dashboard", label: "Dashboard", icon: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" },
	{ key: "weekly", label: "Rapport hebdo", icon: "M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" },
	{ key: "templates", label: "Templates", icon: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z" },
	{ key: "exercices", label: "Exercices", icon: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z" },
	{ key: "programmes", label: "Programmes", icon: "M4 5h16v2H4zm0 6h16v2H4zm0 6h10v2H4z" },
];

export default function CoachSidebar({
	view,
	onSelectView,
	students,
	selectedStudent,
	user,
	studentScores,
	onSelectStudent,
	onStudentMessage,
	onStudentNote,
	onStudentPlan,
	onInviteStudent,
	mobileOpen = false,
	onMobileClose,
}) {
	const [filter, setFilter] = useState("");

	const scoresMap = useMemo(() => {
		const m = {};
		(studentScores || []).forEach((s) => {
			m[s.id] = s;
		});
		return m;
	}, [studentScores]);

	const allStudents = useMemo(() => {
		const list = [];
		if (user && user.id) {
			list.push({ id: user.id, prenom: user.prenom, nom: user.nom, photoProfil: user.photoProfil, isSelf: true });
		}
		(students || []).forEach((s) => list.push(s));
		return list;
	}, [students, user]);

	const filteredStudents = useMemo(() => {
		if (!filter.trim()) return allStudents;
		const q = filter.trim().toLowerCase();
		return allStudents.filter((s) =>
			(`${s.prenom || ""} ${s.nom || ""}`).toLowerCase().includes(q)
		);
	}, [allStudents, filter]);

	// Wrappers pour fermer automatiquement le drawer mobile après une sélection
	// (comportement standard : le user tap un item → drawer se ferme → il voit le contenu).
	const handleSelectView = (key) => {
		onSelectView?.(key);
		onMobileClose?.();
	};
	const handleSelectStudent = (s) => {
		onSelectStudent?.(s);
		onMobileClose?.();
	};

	return (
		<>
			{/* Backdrop mobile : ferme le drawer au tap hors de la sidebar */}
			<div
				className={`coach-sidebar-backdrop ${mobileOpen ? "open" : ""}`}
				onClick={onMobileClose}
				aria-hidden="true"
			/>
		<aside className={`coach-sidebar ${mobileOpen ? "mobile-open" : ""}`}>
			<nav className="coach-sidebar-nav">
				{NAV_ITEMS.map((item) => (
					<button
						key={item.key}
						className={`coach-sidebar-nav-item ${view === item.key ? "active" : ""}`}
						onClick={() => handleSelectView(item.key)}
					>
						<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
							<path d={item.icon} />
						</svg>
						<span>{item.label}</span>
					</button>
				))}
			</nav>

			<div className="coach-sidebar-divider" />

			<div className="coach-sidebar-section-header">
				<span className="coach-sidebar-section-title">
					Élèves <span className="coach-sidebar-count">{allStudents.length}</span>
				</span>
				{onInviteStudent && (
					<button
						type="button"
						className="coach-sidebar-invite-btn"
						onClick={onInviteStudent}
						title="Inviter un nouveau client par email"
						aria-label="Inviter un nouveau client"
					>
						<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
							<line x1="12" y1="5" x2="12" y2="19" />
							<line x1="5" y1="12" x2="19" y2="12" />
						</svg>
						<span>Inviter</span>
					</button>
				)}
			</div>

			<div className="coach-sidebar-filter">
				<input
					type="text"
					value={filter}
					onChange={(e) => setFilter(e.target.value)}
					placeholder="Filtrer…"
					className="coach-sidebar-filter-input"
				/>
			</div>

			<div className="coach-sidebar-students">
				{filteredStudents.length === 0 && (
					<div className="coach-sidebar-empty">Aucun élève</div>
				)}
				{filteredStudents.map((s) => (
					<StudentListItem
						key={s.id}
						student={s}
						score={scoresMap[s.id]}
						isActive={view === "student" && selectedStudent?.id === s.id}
						onClick={() => handleSelectStudent(s)}
						onMessage={onStudentMessage}
						onNote={onStudentNote}
						onPlan={onStudentPlan}
					/>
				))}
			</div>
		</aside>
		</>
	);
}
